module.exports = __webpack_public_path__ + "img/46_15.af6d5e31.png";